<template>
    <div class="copy-create">
        <div class="form-box mb10">
            <el-form inline :model="formData" size="mini" ref="formInline" @submit.native.prevent="handleOnSubmit">
                
                <el-form-item prop="copy_id">
                    <CustomInput label='任务ID'>
                        <el-input
                            v-model="formInline.copy_id"
                            placeholder="任务ID"
                            style="width: 100px"
                            clearable
                            @keyup.enter.native="handleOnSubmit"
                        ></el-input>
                    </CustomInput>
                </el-form-item>

                <el-form-item prop="account_ids">
                    <CustomInput label='账户'>
                        <ESelect
                            v-model="formInline.account_ids"
                            filterable
                            clearable
                            placeholder="被复制账户名称或ID关键字"
                            multiple
                            collapse-tags
                            remote
                            reserve-keyword
                            :loading="searchLoading"
                            ref="account_ids"
                            @visible-change="(val)=>handleVisibleChange(val, 'account')"
                            :remote-method="(search) => appEntrySearchList(search, 'account')"
                            style="width: 260px"
                        >
                            <!-- <p class="option-select">
                                <el-button type="text" @click="()=>handleSelectAll(work_order_DataList, 'work_order', 'all')">全选</el-button>
                                <el-button type="text" @click="()=>handleSelectAll(work_order_DataList, 'work_order', 'cancel')">取消全选</el-button>
                            </p> -->
                            <el-option
                                v-for="item in account_DataList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </ESelect>
                    </CustomInput>
                </el-form-item>

                

                

                <el-form-item prop="source_plan_ids">
                    <CustomInput label='计划'>
                        <ESelect
                            v-model="formInline.source_plan_ids"
                            filterable
                            clearable
                            placeholder="被复制计划名称或ID关键字"
                            multiple
                            collapse-tags
                            remote
                            reserve-keyword
                            :loading="searchLoading"
                            ref="source_plan_ids"
                            @visible-change="(val)=>handleVisibleChange(val, 'plan')"
                            :remote-method="(search) => appEntrySearchList(search, 'plan')"
                            style="width: 260px"
                        >
                            <!-- <p class="option-select">
                                <el-button type="text" @click="()=>handleSelectAll(work_order_DataList, 'work_order', 'all')">全选</el-button>
                                <el-button type="text" @click="()=>handleSelectAll(work_order_DataList, 'work_order', 'cancel')">取消全选</el-button>
                            </p> -->
                            <el-option
                                v-for="item in plan_DataList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </ESelect>
                    </CustomInput>
                </el-form-item>

                <el-form-item prop="creator">
                    <CustomInput label='创建人'>
                        <ESelect
                                v-model="formInline.creator"
                                placeholder="名称关键字"
                                style="width: 220px"
                                multiple
                                collapse-tags
                                clearable
                                filterable
                            >
                            <el-option
                                v-for="item in creator"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </ESelect>
                    </CustomInput>
                </el-form-item>

                <el-form-item prop="department">
                    <CustomInput label='创建部门'>
                        <ESelect
                                v-model="formInline.department"
                                placeholder="名称关键字"
                                style="width: 200px"
                                clearable
                                filterable
                                multiple
                                collapse-tags
                            >
                            <el-option
                                v-for="item in department"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </ESelect>
                    </CustomInput>
                </el-form-item>


                <el-form-item prop="range_time">
                    <CustomInput label='创建时间'>
                        <el-date-picker
                            v-model="formInline.range_time"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            value-format="yyyy-MM-dd"
                            end-placeholder="结束时间"
                            :picker-options="basePickerOptions"
                            :clearable="false"
                        >
                        </el-date-picker>
                    </CustomInput>
                </el-form-item>

                <el-form-item prop="status">
                    <CustomInput label='任务状态'>
                        <ESelect
                            v-model="formInline.status"
                            placeholder="任务状态"
                            style="width: 180px"
                            multiple
                            collapse-tags
                            clearable
                        >
                            <el-option
                                label="排队中"
                                value="0"
                            ></el-option>
                            <el-option
                                label="创建中"
                                value="1"
                            ></el-option>
                            <el-option
                                label="创建成功"
                                value="2"
                            ></el-option>
                            <el-option
                                label="创建失败"
                                value="3"
                            ></el-option>
                            <el-option
                                label="部分创建失败"
                                value="4"
                            ></el-option>
                        </ESelect>
                    </CustomInput>
                </el-form-item>

            </el-form>
            <div class="opts">
                <el-button type="primary" size="mini" @click="handleOnSubmit(false)">查询</el-button>
                <el-button size="mini" @click="resetForm('formInline')">清空筛选</el-button>
            </div>
        </div>
        <div class="bg-white pt10 pl10 pr10 pb10 borderRadius5 order_table_no_border">
            <div class="operation-box mb10">
                <div class="operation-left">
                    <el-button
                    type="primary"
                    size="mini"
                    @click="handleCopyPlan"
                    v-if="getCurAuth('oppo_plan_copy_create')"
                    v-matomo="{behaviorCategory: 'OPPO(计划复制)',  name: '创建' }"
                    >计划复制</el-button>
                </div>
                <div class="operation-right">
                   
                </div>
            </div>
            <jt-table
                    :data="tableData"
                    style="width: 100%"
                    stripe
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    size="mini"
                    class="create_list"
                    :row-class-name="tableRowClassName"
                    v-loading="loading"
                    tooltip-effect="dark"
                >
                    <el-table-column label="任务ID" width="80" prop="copy_id">
                        <template slot-scope="scope">
                            <span v-if="scope.row.copy_id">{{ scope.row.copy_id }}</span>
                            <span v-else>汇总</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="被复制账户&计划" min-width="300">
                        <template slot-scope="scope">
                            <div v-if="scope.$index != 0">
                                <div @click="handleShowInfo(scope.row)" style="cursor: pointer;">
                                    <p>账户：{{ getAccount(scope.row) }}</p>
                                    <p>计划：{{ getPlan(scope.row) }}</p>
                                </div>

                            </div>
                            <span v-else>
                                账户：{{scope.row.account_distinct_num}}/{{scope.row.account_num}}；
                                计划：{{scope.row.plan_distinct_num}}/{{scope.row.plan_num}}；
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="新计划状态" min-width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.$index != 0">{{ scope.row.new_status_text }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="被复制计划状态" min-width="130">
                        <template slot-scope="scope">
                            <span v-if="scope.$index != 0">{{ scope.row.old_status_text }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="投放日期" min-width="200">
                        <template slot-scope="scope">
                            <span v-if="scope.$index != 0">{{ getTfdate(scope.row) }}</span>
                            <span v-else>
                                -
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="创建计划规格(成功数量/总量)"
                        min-width="300"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div>
                                <p>
                                    计划(<span class="text-color-success">{{ scope.row.success_plan_num }}</span>/<span>{{ scope.row.total_plan_num }}</span>)；
                                    广告组(<span class="text-color-success">{{ scope.row.success_adgroup_num }}</span>/<span>{{ scope.row.total_adgroup_num }}</span>)；
                                    广告(<span class="text-color-success">{{ scope.row.success_ad_num }}</span>/<span>{{ scope.row.total_ad_num }}</span>)；
                                </p>
                            </div>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="任务状态" width="150">
                        <template slot-scope="scope">
                            <div v-if="scope.$index != 0">
                                <p v-if="scope.row.status == 0" style="color: #a9a9a9;">{{ scope.row.status_text}}</p>
                                <p v-else-if="scope.row.status == 1" style="color: #409eff;">{{ scope.row.status_text}}<i class="el-icon-loading"></i></p>
                                <p v-else-if="scope.row.status == 2" class="text-color-success">{{ scope.row.status_text}}</p>
                                <div v-else class="text-color-error text-nowrap">
                                    <el-tooltip class="item" effect="dark"  placement="top" v-if="scope.row.err_msg">
                                        <div slot="content">
                                            <p class="mb6">您可点击任务详情查看具体失败计划，失败原因如下：</p>
                                            <div v-html="scope.row.err_msg.replace(/\\n/g, '<br/>')"></div>
                                        </div>
                                        <span class="pointer">{{ scope.row.status_text}}<i class="el-icon-warning-outline"></i></span>
                                    </el-tooltip>
                                    <span v-else>{{ scope.row.status_text}}</span>
                                </div>
                            </div>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建人" width="90" prop="creator">
                        <template slot-scope="scope">
                            <span v-if="scope.$index != 0">{{ scope.row.creator }}</span>
                            <span v-else>{{scope.row.creator_distinct_num}}/{{scope.row.creator_num}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间" width="90" prop="create_time">
                        <template slot-scope="scope">
                            <span v-if="scope.$index != 0">{{ scope.row.create_time }}</span>
                            <span v-else>—</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180" fixed="right">
                        <template slot-scope="scope">
                            <el-button v-if="scope.$index != 0" size="mini" type="text"
                            @click="handleInfoPlan(scope.$index, scope.row)"
                            v-matomo="{behaviorCategory: 'OPPO(计划复制)',  name: '任务详情' }"
                                >任务详情</el-button>
                                <el-button v-if="scope.$index != 0 && getCurAuth('oppo_plan_copy_task')" size="mini" type="text"
                                v-matomo="{behaviorCategory: 'OPPO(计划复制)',  name: '复制' }"
                                @click="handleCopy(scope.$index, scope.row)">复制</el-button>
                            <el-button v-if="scope.$index != 0 && getCurAuth('oppo_plan_copy_task_retry')" size="mini" type="text" 
                            v-matomo="{behaviorCategory: 'OPPO(计划复制)',  name: '重试' }"
                            @click="handleRetry(scope.$index, scope.row)" :disabled="(scope.row.status!='3'&&scope.row.status!='4')" :loading="scope.row.retryLoading">重试</el-button>
                            <!-- <span v-else>-</span> -->
                        </template>
                    </el-table-column>
                </jt-table>
                <div style="text-align: right; margin-top: 10px;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page.sync="currentPage" :page-sizes="[30, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
        </div>
    </div>
</template>
<script>
    import CustomInput from '@/components/CustomInput'
    import API from '@/api/marketManage/oppoCopyPlan.js'
    import {copyPlanInfoModal} from '../modal/index.js';
    import _ from 'lodash';
    import dayjs from "dayjs";
    export default {
        components: {CustomInput},
        props: {
            pageFuncNames: Array
        },
        data() {
            return {
                basePickerOptions: {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [
                        {
                            text: '最近7天',
                            onClick(picker) {
                                const date = new Date();
                                let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 7);
                                let endDate = new Date(date.getTime());
                                picker.$emit('pick', [startDate,endDate]);
                            }
                        },
                        {
                            text: '上周',
                            onClick(picker) {
                                // 上周：自然周，周一到周日
                                let date = new Date(new Date().getTime()-1000*60*60*24*7);
                                let weekDay = date.getDay();
                                let startDate = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
                                let endDate = new Date(startDate.getTime() + 1000*60*60*24*6);
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate = year+'-'+month+'-1';
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '上月',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth();
                                let startDate = new Date(year+'-'+month+'-01');
                                let endDate = new Date(new Date(year+'-'+(month+1)+'-01').getTime()-1000*60*60*24);
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本季度',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate='';
                                if([1,2,3].includes(month)){
                                    startDate = year+'-01-01';
                                }else if([4,5,6].includes(month)){
                                    startDate = year+'-04-01';
                                }else if([7,8,9].includes(month)){
                                    startDate = year+'-07-01';
                                }else if([10,11,12].includes(month)){
                                    startDate = year+'-10-01';
                                }
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                        text: '上季度',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth()+1;

                            let startDate='';
                            let endDate = '';
                            if([1,2,3].includes(month)){
                                startDate = (year-1)+'-10-01';
                                endDate = (year-1)+'-12-31';
                            }else if([4,5,6].includes(month)){
                                startDate = year+'-01-01';
                                endDate = year+'-03-31';
                            }else if([7,8,9].includes(month)){
                                startDate = year+'-04-01';
                                endDate = year+'-06-30';
                            }else if([10,11,12].includes(month)){
                                startDate = year+'-07-01';
                                endDate = year+'-09-30';
                            }
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '今年',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let startDate= year+'-01-01';
                            let endDate = year+'-12-31';
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '去年',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear()-1;
                            let startDate= year+'-01-01';
                            let endDate = year+'-12-31';
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    }
                    ]
                },
                formInline: {
                    copy_id: "",        //任务ID
                    account_ids: "",     //账户ID
                    source_plan_ids:"",  //计划
                    creator: "",        //创始人
                    department: "",     //创始部门
                    range_time:[],
                    status:""           //任务状态
                },
                formData: {
                    material_group: [],
                    material_uid: [],
                   create_uid: [],
                },
                account_DataList:[],
                plan_DataList:[],
                creator: [],            //创建人
                department: [],         //创建人部门
                loading: false,
                searchLoading: false,
                tableData: [],
                currentPage: 1,
                pageSize: 30,
                total: null,
                checkStatusTimer: null, // 添加定时器变量
                isComponentMounted: true,
            }
        },
        mounted() {
            
            let query_store = window.localStorage.getItem('copyListPage')
            if(query_store){
                let query_store_json = JSON.parse(query_store)
                this.formInline.copy_id = query_store_json?.copy_id;        //任务ID
                this.formInline.account_ids = query_store_json?.account_ids;     //账户ID
                this.formInline.source_plan_ids=query_store_json?.source_plan_ids;  //计划
                this.formInline.creator = query_store_json?.creator;        //创始人
                this.formInline.department = query_store_json?.department
                this.formInline.status = query_store_json?.status
                this.currentPage = Number(query_store_json?.pn);
                this.pageSize = Number(query_store_json?.rn);
                
                this.handleOnSubmit()
                window.localStorage.removeItem('copyListPage')
            }
            this.clearTimes()
            this.renovate()
            let startDate = dayjs().subtract(6, 'day').format("YYYY-MM-DD");
            let endDate = dayjs().format("YYYY-MM-DD");
            this.formInline.range_time = [startDate, endDate]

            if(this.$route.query.id) {
                this.formInline.copy_id = this.$route.query.id
                this.handleOnSubmit()
            }else{
                // this.getList()
                this.handleOnSubmit()
            }
        },
        methods: {
            getTfdate(row) {
                if(row.start_date && row.end_date) {
                    return row.start_date + '-' + row.end_date
                }else {
                    return '长期'
                }
            },
            getAccount(row) {
                let result = _.head(row.source_account_plan_info)
                let num = row.source_account_plan_info?.length
                let text = (!num || num <= 1) ? '' : `+ ${num - 1}`
                return `${result.account_name}${text}`
            },
            getPlan(row) {

                let result = _.head(row.source_account_plan_info)
                let plan = _.head(result.plan_list)
                let num = row.source_account_plan_info.reduce((total, account) => {
                    return total + account.plan_list.length;
                }, 0);
                let text = (!num || num <= 1) ? '' : `+ ${num - 1} `
                return `${plan.plan_name}${text} ` 
            },
            renovate() {
                let arr = ['creator', 'department']
                arr.forEach(item => {
                    API.getTaskSearchList({ search_type: item }, {cancel:false}).then(res => {
                        let result = res.data
                        this[item] = result
                    })
                })
            },
            // 操作权限
            getCurAuth(name) {
                return this.pageFuncNames.includes(name);
            },
            tableRowClassName({row, rowIndex}) {
                if (rowIndex === 0) {
                    return 'gray-row';
                }
                return '';
            },
            appEntrySearchList: _.throttle(async function (search, type, p ={}, cb) {
                this.getOptions(search, type, p ={}, cb)
            }, 1000),
            // 下拉检索
            async getOptions(search, type, p ={}, cb) {
                try {
                    const params = {
                        search_type: type,
                        search,
                        ...p
                    };
                    this.searchLoading = true
                    const { data } = await API.getTaskSearchList(params);
                    const list = data;
                    const errList = data.err_list;
                    if (params.batch_search) {
                        cb(errList, ()=> {
                            const ids = list.map(v=>v.id)
                            this[`${type}_DataList`] = [
                                ...this[`${type}_DataList`].filter(v=>this.formInline[type].includes(v.value)&&!ids.includes(v.value)),
                            ]
                            if(type == 'account') {
                                this.formInline['account_ids'] = [...new Set([ ...this.formInline['account_ids'], ...ids ])];
                            }else{
                                this.formInline['source_plan_ids'] = [...new Set([ ...this.formInline['source_plan_ids'], ...ids ])];
                            }
                        })
                    }else {
                        this[`${type}_DataList`]= list
                    }
                } catch (error) {
                    this.$message.warning(error.info)
                } finally {
                    this.searchLoading = false
                }
            },
            handleVisibleChange(visible, type) {
                if (visible) {
                    const options = this.$refs[type]?.selected|| [];
                    const listData = options &&  options.map(v=> {
                        return v.$options.propsData
                    });
                    this.$set(this, `${type}_DataList`, listData)
                }
            },
            async getList(params) {
                try {
                    this.loading = true;
                    // 使用 Promise.all 同时发起两个请求
                    const [listRes, totalRes] = await Promise.all([
                        API.postTaskList(params),
                        API.postTaskTotal(params)
                    ]);
                    
                    // 检查接口返回状态码
                    if (listRes.code == 200 && totalRes.code == 200) {
                        // 两个接口都成功返回后设置数据
                        let list = listRes.data.list.map(v=>{
                            return {
                                ...v,
                                ...v.detail_num_info
                            }
                        })
                        this.tableData = [totalRes.data, ...list];
                        this.total = listRes.data.totalCnt;
                        
                        // this.$nextTick(()=>{
                        //     this.currentPage = listRes.data.pageNum;
                        //     this.pageSize = listRes.data.pageSize;
                        //     console.log('---------------', this.currentPage)
                        // })
                        this.checkTaskStatus(params)
                    }
                } catch (error) {
                    // 处理错误
                    // console.log('error', error)
                    // this.$message.error(error.info || '获取数据失败');
                } finally {
                    this.loading = false;
                }
            },
            checkTaskStatus(params) {
                // 清除之前的定时器
                if (this.checkStatusTimer) {
                    clearTimeout(this.checkStatusTimer);
                }
                if (!this.isComponentMounted) return;
                
                // 创建新的定时器
                this.checkStatusTimer = setTimeout(() => {
                    // 再次检查组件是否已卸载
                    if (!this.isComponentMounted) {
                        if (this.checkStatusTimer) {
                            clearTimeout(this.checkStatusTimer);
                        }
                        return;
                    }
                    API.postTaskTotal(params).then(res=>{
                        if (this.isComponentMounted) {
                            this.$set(this.tableData, 0, res.data)
                        }
                    })
                    API.postTaskList(params).then(res => {
                        if (!this.isComponentMounted) return;
                        this.handleResponse(res);
                        
                        // 检查状态，如果包含0或1则继续请求
                        if (res.data.list.some(item => item.status == 0 || item.status == 1)) {
                            this.checkTaskStatus(params);
                        }
                        // this.checkTaskStatus(params);
                    }).catch(err => {
                        console.error('请求失败:', err);
                        if (this.checkStatusTimer) {
                            clearTimeout(this.checkStatusTimer);
                        }
                    });
                }, 5000);
            },
            handleResponse(res) {
                // 处理返回数据的逻辑
                // 例如更新表格数据等
                let first_item = this.tableData[0] || []
                let list = res.data.list.map(v=>{
                    return {
                        ...v,
                        ...v.detail_num_info
                    }
                })
                this.tableData = [first_item , ...list]
            },
            handleRetry(index, row) {
                API.postRetryTask({copy_id:row.copy_id}).then(res => {
                    this.$message.success('重试成功')
                    this.handleOnSubmit()
                }).catch(err => {
                    this.$message.warning(err.info)
                })
            },
            handleOnSubmit() {
                this.clearTimes()
                
                if(!this.formInline.copy_id) {
                    this.$router.push({
                        name:'oppo_plan_copy',
                    });
                }
                console.log('this.formInline------------', this.currentPage, this.pageSize)
                
                this.getList({...this.formInline,range_time: this.formInline.range_time.join('/'), pn: this.currentPage, rn: this.pageSize})
            },
            // 每页条数
            handleSizeChange(val) {
                this.pageSize = val
                this.handleOnSubmit()
            },
            // 当前页数
            handleCurrentChange(val) {
                this.currentPage = val
                this.handleOnSubmit()
            },
            resetForm(action) {
                this.formInline.copy_id = "";        //任务ID
                this.formInline.account_ids = "";     //账户ID
                this.formInline.source_plan_ids="";  //计划
                this.formInline.creator = "";        //创始人
                this.formInline.department = ""
                this.formInline.status = ""
                this.currentPage = 1;
                this.pageSize = 30;
                this.clearTimes()
                // this.$router.push({
                //     name: 'oppo_plan_copy',
                //     params: {
                //         type: 'list'
                //     },
                //     query: {
                //         ...this.formInline,
                //         range_time: this.formInline.range_time.join('/'),
                //         pn: this.currentPage,
                //         rn: this.pageSize
                //     }
                // })
                this.getList({...this.formInline,range_time: this.formInline.range_time.join('/'), pn: this.currentPage, rn: this.pageSize})
            },
            handleShowInfo(row) {
                let result = row.source_account_plan_info.map(v=> {
                    return {
                        id: v.account_id,
                        label: v.account_name,
                        children: v.plan_list.map(v=> {
                            return {
                                id: v.plan_id,
                                label: `${v.plan_name}`
                            }
                        })
                    }
                })
                const {vm} = copyPlanInfoModal(
                    {
                        props: {
                            list: result
                        }
                    }
                )
            },
            handleCopyPlan() {
                window.localStorage.setItem('copyListPage', '')
                this.toPage('/marketing_management/oppo/oppo_plan_copy/create')
            },
            handleCopy(index, row) {
                let store = {
                    ...this.formInline,
                    range_time: this.formInline.range_time.join('/'),
                    pn: this.currentPage,
                    rn: this.pageSize
                }
                window.localStorage.setItem('copyListPage', JSON.stringify(store))
                this.toPage('/marketing_management/oppo/oppo_plan_copy/copy', {id: row.copy_id})
            },
            handleInfoPlan(index, row) {
                let store = {
                    ...this.formInline,
                    range_time: this.formInline.range_time.join('/'),
                    pn: this.currentPage,
                    rn: this.pageSize
                }
                window.localStorage.setItem('copyListPage', JSON.stringify(store))
                this.toPage('/marketing_management/oppo/oppo_plan_copy/info', {id: row.copy_id})
            },
            toPage(path, p ={}) {
                this.$router.push({
                    path: path,
                    query: {
                        ...this.$route.query,
                        ...p
                    }
                });
            },
            clearTimes() {
                if (this.checkStatusTimer) {
                    clearTimeout(this.checkStatusTimer);
                    this.checkStatusTimer = null; // 添加这行以确保完全清除
                }
            }
        },
        beforeDestroy() {
            // 清除定时器
            this.isComponentMounted = false;
            if (this.checkStatusTimer) {
                clearTimeout(this.checkStatusTimer);
                this.checkStatusTimer = null;
            }
        }
    }
</script>
<style lang="scss" scoped>
@import "~@/styles/material_sd.scss";
.copy-create{

}
.opts {
    border-top: 1px solid #DCDFE6;
    padding-top: 10px;
}
.form-box {
    background: #ffffff;
    padding: 20px 10px;
    border-radius: 4px;
}
.table-context {
    background-color: #fff;
    margin-top: 12px;
    border-radius: 4px;
    padding-top: 12px;
}
</style>